<template>
    <v-btn
        color="#3C8DBC"
        class="btn-search"
        :disabled="disabled"
        @click="callback"
    >
        Search
    </v-btn>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            callback: {
                type: Function,
                required: true
            }
        }
    }
</script>

<style scoped>
.btn-search {
    color: white;
}
</style>
